import { Mail, Radio } from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-bg-elevated border-t border-border-primary">
      <div className="max-w-7xl mx-auto px-4 py-6">
        <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
          {/* Brand */}
          <div className="flex items-center gap-2">
            <Radio className="w-4 h-4 text-accent-primary" />
            <span className="font-display font-bold text-accent-primary">
              KQ4TNV
            </span>
            <span className="text-text-secondary text-sm">• Stafford, VA</span>
          </div>

          {/* Links */}
          <div className="flex items-center gap-6 text-sm">
            <Link
              to="/"
              className="text-text-secondary hover:text-accent-primary transition-colors"
            >
              Home
            </Link>
            <Link
              to="/connect"
              className="text-text-secondary hover:text-accent-primary transition-colors"
            >
              Connect
            </Link>
            <Link
              to="/wiresx"
              className="text-text-secondary hover:text-accent-primary transition-colors"
            >
              WIRES-X
            </Link>
            <Link
              to="/resources"
              className="text-text-secondary hover:text-accent-primary transition-colors"
            >
              Resources
            </Link>
            <a
              href="mailto:repeater@kq4tnv.net"
              className="text-text-secondary hover:text-accent-primary transition-colors flex items-center gap-1"
            >
              <Mail className="w-3 h-3" />
              Contact
            </a>
          </div>
        </div>

        {/* Copyright */}
        <div className="text-center mt-4 pt-4 border-t border-border-primary/50">
          <p className="text-text-secondary/60 text-xs">
            © {currentYear} KQ4TNV. Built with{" "}
            <span className="text-accent-highlight">♥</span> for the ham radio
            community.
          </p>
        </div>
      </div>
    </footer>
  );
}
